import { IApplicationState, TActivityId } from '../../../../../../types/types';
import { getAsidePanel } from './getAsidePanel';

export const getAsidePanelActivityId = (
    state: IApplicationState
): TActivityId => {
    return getAsidePanel(state).activityId;
};
